export default __webpack_public_path__ + "static/media/github.77a97279.png";